const contactHeaderReducer = (
    state = {
      data: [],
    },
    action: {
      type: "SET_CONTACT_HEADER_LIST";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_CONTACT_HEADER_LIST":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default contactHeaderReducer;
  